import { SearchParams, Contract } from '@/types/orderhistory';
import { http } from './http.service';
import { DispatchNote, Invoice, OrderDetail } from '@/types/order';
import { CancelOrderRequest } from '@/types/cancel-order';
class OrderHistoryService {
  getOrderList = async (searchParams: SearchParams) => {
    let listUrl = `/api/order/search?pageSize=${searchParams.pageSize}&pageNo=${searchParams.pageNumber}`;
    if (searchParams.orderBy && Object.keys(searchParams.orderBy).length > 0) {
      listUrl = `${listUrl}&orderBy=${Object.keys(searchParams.orderBy)[0]}:${Object.values(searchParams.orderBy)[0]}`;
    }
    let requestParam = {};
    if (searchParams.advanceSearchParams) {
      requestParam = { ...searchParams.advanceSearchParams };
    }
    const response = await http.post(listUrl, requestParam);
    return response;
  };

  getMiniOrder = async (orderNumber: string, webOrderNumber: string) => {
    const response = await http.get<OrderDetail>(
      `/api/order/miniOrder?orderNumber=${orderNumber}&webOrderNumber=${webOrderNumber}`
    );
    return response;
  };

  getOrderDetails = async (orderNumber: string, webOrderNumber: string) => {
    const response = await http.get<OrderDetail>(
      `/api/order/detail?orderNumber=${orderNumber}&webOrderNumber=${webOrderNumber}`
    );
    return response;
  };

  reOrder = async (items: Array<{ catalogNumber: string; quantity: number }>) => {
    const response = await http.post(`/api/order/reorder`, { orderLines: items });
    return response;
  };

  exportOrder = async (searchParams: SearchParams) => {
    let listUrl = `/api/order/export?pageSize=${searchParams.pageSize}&pageNo=${searchParams.pageNumber}&excelFlag=${searchParams.excelFlag}`;
    if (searchParams.orderBy && Object.keys(searchParams.orderBy).length > 0) {
      listUrl = `${listUrl}&orderBy=${Object.keys(searchParams.orderBy)[0]}:${Object.values(searchParams.orderBy)[0]}`;
    }
    let requestParam = {};
    if (searchParams.advanceSearchParams) {
      requestParam = { ...searchParams.advanceSearchParams };
    }
    const response = await http.post(listUrl, requestParam, { responseType: 'blob' });
    return response;
  };

  getPriceContract = async (orderNumber: string) => {
    const response = await http.get<Contract>(`/api/contract/info?orderNumber=${orderNumber}`);
    return response;
  };

  getDispatchNote = async (orderNumber: string) => {
    const response = await http.get<DispatchNote[]>(`/api/order/dispatch/note/pdf?orderNumber=${orderNumber}`);
    return response;
  };

  getInvoice = async (orderNumber: string) => {
    const response = await http.get<Invoice[]>(`/api/order/invoice/pdf?orderNumber=${orderNumber}`);
    return response;
  };
  getCancelStatus = async (params) => {
    const response = await http.get(
      `/api/order/queryCancellableOrderInfo?e1OrderNumber=${params?.orderNumber}&PONumber=${params?.PONumber}&webOrderNumber=${params?.webOrderNumber}`
    );
    return response;
  };
  cancelOrder = async (data: CancelOrderRequest) => {
    const response = await http.post(`/api/order/cancelOrder`, data);
    return response;
  };
  uploadAttachment = async (file: any, orderNumber: string) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await http.fileUpload(`api/order/uploadCancelOrderAttachmentFile/${orderNumber}`, formData);
    return response;
  };
  getDeliveryDetails = async (dnNumbers: string) => {
    const response = await http.get(`/api/order/delivery?dnNumbers=${dnNumbers}`);
    return response;
  };
  checkDeliveryConfirmation = async (dnNumbers: string) => {
    const response = await http.get(`/api/order/queryDeliveryConfirm?dnNumbers=${dnNumbers}`);
    return response;
  };
  updateDeliveryConfirmation = async (params) => {
    const response = await http.post(`/api/order/submitDeliveryConfirm`, params);
    return response;
  };
  cancelReasonData = async () => {
    const response = await http.get(`/api/order/getOrderCancelReasonSelection`);
    return response;
  };
}
export const orderHistoryService = new OrderHistoryService();
